import { render, staticRenderFns } from "./SignUpForOnlineCoaching.vue?vue&type=template&id=5d92b61a&scoped=true&"
import script from "./SignUpForOnlineCoaching.vue?vue&type=script&lang=ts&"
export * from "./SignUpForOnlineCoaching.vue?vue&type=script&lang=ts&"
import style0 from "./SignUpForOnlineCoaching.vue?vue&type=style&index=0&id=5d92b61a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d92b61a",
  null
  
)

export default component.exports